import React from 'react';
import { Broadcast, CircleSpinner } from '../../../assets/svg';
import { broadcastRegulatoryIssues, popup } from '../../../utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS, REGULATORY_ISSUE } from '../../../constants';

const BroadcastButton = ({ data }) => {
    const queryClient = useQueryClient();

    const broadcastMutation = useMutation({
        mutationFn: async () => await broadcastRegulatoryIssues({ id: data.id }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.REGULATORY_ISSUE] });
            popup('success', REGULATORY_ISSUE.BROADCASTED);
        },
        onError: (error) => {
            popup('error', error.message);
        },
    });

    const clickHandler = () => {
        broadcastMutation.mutate();
    };

    return (
        <div className='text-center hov-effect-boardcast'>
            <button
                className={
                    'border-0 p-0 background-color-transparent ' +
                    (data.broadcasted_at !== null ? ' cursor-na' : '')
                }
                disabled={data.broadcasted_at !== null}
                onClick={clickHandler}
                title={data.broadcasted_at !== null ? '' : 'Broadcast'}
            >
                {broadcastMutation.isPending ? (
                    <CircleSpinner />
                ) : (
                    <Broadcast color={data.broadcasted_at !== null ? '#4b5564' : '#17B1A4'} />
                )}
            </button>
        </div>
    );
};

export default BroadcastButton;
